import { mapGetters, mapActions } from 'vuex'

const roomMixin = {
  data () {
    return {
      showNav: false,
      showConfirm: false,
      roomId: -1
    }
  },
  computed: {
    ...mapGetters(['getRoom', 'getRoomQuestions', 'getQuestions', 'getFollowUpQuestionAsked']),
    followUpQuestionAsked () {
      return this.getFollowUpQuestionAsked
    },
    questions () {
      return this.getQuestions
    },
    questionsAnswered () {
      return this.questions.filter(q => q.answered).length
    },
    room () {
      return this.getRoom(this.roomId)
    },
    roomInstruction () {
      return this.room.instruction
    },
    roomQuestions () {
      return this.getRoomQuestions(this.roomId)
    },
    roomQuestionsAnswered () {
      return this.roomQuestions.filter(q => q.answered).length
    },
    roomQuestionsLength () {
      return this.roomQuestions.length
    },
    showFollowUpQuestion () {
      if (this.$isUcas) {
        return false
      }

      if (this.followUpQuestionAsked) {
        return false
      }

      const questionsRemaining = this.questions.length - this.questionsAnswered
      return questionsRemaining <= 1
    }
  },
  methods: {
    ...mapActions(['updateInstruction', 'setFollowUpQuestionAsked']),
    closeInstruction (roomName) {
      if (this.roomInstruction !== true) {
        this.updateInstruction(roomName)
      }
    },
    followUpQuestionClosed () {
      this.setFollowUpQuestionAsked()
    },
    selectQuestion (question) {
      this.closeInstruction(this.room.name)
      this.$router.push(
        {
          name: 'question',
          params: {
            room: this.room.id,
            question: this.roomQuestions[question].relativeID
          }
        })
    },
    updateNav () {
      let q = this.roomQuestions
      let a = []
      for (let index = 0; index < q.length; ++index) {
        a.push(q[index].answered)
      }

      this.showNav = (Object.keys(a).every(i => a[i]))
    }
  }
}

export default roomMixin



// WEBPACK FOOTER //
// ./src/mixins/roomMixin.js